
export const formatarData = (data) => {
  if ( (data === undefined) || (data === null) || (data === '') ) {
    return '(não registrado)';
  }
  const date = new Date(data);
  const customFormatter = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  return customFormatter.format(date).replace(",","");
}

export const formatarCPF = (value) => {
  // Remove all non-digit characters
  const digitsOnly = value.replace(/\D/g, '');

  // Limit to 11 digits
  const limitedValue = digitsOnly.slice(0, 11);

  // Apply formatting sequentially based on length
  return limitedValue
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
};

export const formatarTelefone = (value) => {
  if (!value) return "";

  // Remove tudo que não for dígito
  const digits = value.replace(/\D/g, "").slice(0, 15); // Limita a 15 dígitos

  // Aplica a máscara dependendo da quantidade de números
  const newValue = digits
    .replace(/^(\d{2})(\d)/, "($1) $2") // DDD
    .replace(/(\d{5})(\d)/, "$1-$2")     // Hífen do celular (5 dígitos iniciais)
    .replace(/(-\d{4})\d+?$/, "$1");     // Limita o final a 4 dígitos

  return newValue;
};

export const emailEhValido = (email) => {
  if ( (email === undefined) || (email === null) || (email === '') ) {
    return false;
  } else {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
};

export const criarHashKey = (valor, seed = 0) => {
  const unixTimestampMs = Date.now();
  const str = `${valor}#${unixTimestampMs}`;
  let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1  = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2  = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (h2 >>> 0).toString(16).padStart(8, 0) + (h1 >>> 0).toString(16).padStart(8, 0);
};
